import React from 'react'

import Page from "./../../Page";
import EmptyBanner from "./../../../components/EmptyBanner";
import LoadingBanner from "./../../../components/LoadingBanner";
import ErrorBanner from "./../../../components/ErrorBanner";
import TablePagination from "./../../../components/TablePagination";
import StatusFilterDropdown from "./StatusFilterDropdown";
import {Select} from "antd";
import StatusFilter from './TestFilter';

const PAGE_COUNT = 15;

export default class AdminListView extends Page
{
    static path = '';

    static FailedEventName = '';
    static SuccessEventName = '';
    static modelName = '';
    static searchPlaceholder = 'Search by team, talent, or project';
    static tableClass = ''

    static modelClass() {
        return Object;
    };

    static FetchAllRequest() {
        return undefined
    };

    static get storageKey() {
        return `admin${this.modelName}ListParams`
    }

    static statusOptions() {
        return []
    }
    static sortOptions() {
        return []
    }
    static events()
    {
        let pageEvents = super.events();

        let listEvents = {
            [this.SuccessEventName]: async(component, {
                models,
                current_page,
                last_page,
                total
            }) => {

                await component.promisedState({
                    models,
                    error: null,
                    isLoading: false,
                    isLoadingMore: false,
                    currentPage: current_page,
                    lastPage: last_page,
                    total
                });
                component.persistStorage();
            },
            [this.FailedEventName]: (component, request) => {
                if (!this.FetchAllRequest()?.isRunning() && request.didFail) {
                    return component.handleErrorResponse(
                        request, 'error_index_client_projects'
                    );
                }
            },
        }

        return {...pageEvents, ...listEvents}
    }

    constructor(props)
    {
        super(props);

        this.modalRef = React.createRef();

        let params = JSON.parse(
            localStorage.getItem(this.constructor.storageKey)
            || '{}'
        );

        this.state = {
            isLoading: true,
            keywordFilters: {},
            selectedStatuses: [],
            ...params
        }
    }

    async componentDidMount()
    {
        await super.componentDidMount();
        await this.fetchResultsForListView();
    }

    persistStorage() {
        localStorage.setItem(this.constructor.storageKey, JSON.stringify(
            TB.pick(this.state, ['sortDir', 'sortBy','currentPage', 'lastPage', 'total', 'keywordFilters', 'selectedStatuses'])
        ));
    }

    async fetchResultsForParams(params, refresh) {
        return this.constructor.modelClass().fetchAllForAdmin(
            params, true
        );
    };

    async fetchResultsForListView()
    {
        await this.promisedState({
            isLoading: true,
            error: null,
        });

        let params = {};
        for (let key in this.state.keywordFilters) {
            params[key] = TB.pluck(
                [...this.state.keywordFilters[key]],
                'id'
            )
        }
        if (this.state.selectedStatuses.length) {
            params.statuses = [...this.state.selectedStatuses];
        }

        if (this.state.currentPage) {
            params.page = this.state.currentPage;
        }

        if (this.state.sortBy) {
            params.sort_by = this.state.sortBy;
            params.sort_dir = this.state.sortDir;
        }

        await this.persistStorage()

        await this.fetchResultsForParams(
            params, true
        );
    }

    canLoadMore() {
        return !this.state.isLoading && this.state.lastPage > 1;
    }

    async loadMore(page) {
        if (!this.canLoadMore()) {
            return
        }

        await this.promisedState({
            isLoadingMore: true,
            error: null,
            currentPage: page,
            models: undefined
        });
        return this.fetchResultsForListView();
    }

    async searchKeywords(query)
    {
        await this.constructor.modelClass().cancelSearchKeywords();

        await this.promisedState({
            searchQuery: query || ''
        });

        if (!query) {
            return this.promisedState({
                isSearching: false,
                searchError: null,
            });
        }

        await this.promisedState({
            isSearching: true,
            searchError: null,
        });

        let searchResults = await this.constructor.modelClass().searchKeywords(query);

        if (!searchResults) {
            // handle error

            // can't use logic below for this
            // return this.handleErrorResponse(
            //     Opportunity.SearchKeywordsRequest,
            //     'error_search_opportunity_keywords'
            // );
        }

        await this.promisedState({
            searchResults,
            searchError: null,
            isSearching: false,
        });
    }

    async toggleFilterStatus(statuses)
    {
        // let selectedStatuses = TB.map(statuses, 'value');

        let selectedStatuses = TB.map(statuses, status => {
            if (typeof status === 'string') return status;
            return status.value;
        });
        
        // return;

        await this.promisedState({selectedStatuses, currentPage: null, lastPage: null, total: null, sortBy: undefined})

        return this.fetchResultsForListView();
    }

    async onKeywordsChange(keywords) {

        let keywordFilters = TB.groupBy(keywords, 'type')

        await this.promisedState({searchQuery: '',keywordFilters, currentPage: null, lastPage: null, total: null, sortBy: undefined})

        return this.fetchResultsForListView();
    }

    resultsForCurrentPage() {
        if (!TB.isDefined(this.state.currentPage) || this.state.models.length <= PAGE_COUNT) {
            return this.state.models;
        }
        let currentPage = parseInt(this.state.currentPage);

        return TB.slice(this.state.models,(currentPage  - 1) * PAGE_COUNT, currentPage * PAGE_COUNT)
    }

    renderResults()
    {
        if (!this.state.models || this.state.models?.length === 0) {
            return null
        }

        let models = this.resultsForCurrentPage();

        return models.map((model, i) => this.listDetails(model))
    }

    listDetails(model) {
        return []
    }

    mapSearchResults() {
        let {searchResults} = this.state;
        if(!TB.isArray(searchResults) || !searchResults.length) {
            return [];
        }
        return TB.map(searchResults, ({key, title, results}) => {
            return {
                label: title,
                key: key,
                options: TB.map(results, result => {
                    return {
                        ...result,
                        type: key,
                        label: result.name,
                        value: result.id
                    }
                })
            }
        })
    }

    listHeaders() {
        return []
    }

    sortedHeader(label, fieldName) {
        return (
            <span onClick={() => this.toggleSortColumn(fieldName)}
                  className={"clickable flex flex-row flex-nowrap items-center"}>
                {label} <i className={this.getSortIcon(fieldName)}/>
            </span>
        )
    }

    getSortIcon(sortField) {
        let sortIcon = `text-info fa-sort-${this.state.sortDir === 'asc' ? 'up' : 'down'}`
        return TB.mapClass('ml-1 fa', {
            'fa-sort': this.state.sortBy !== sortField,
            [sortIcon]: this.state.sortBy === sortField
        });
    }

    async toggleSortColumn(sortField) {
        let sortDir = 'asc';
        let sortBy = sortField;

        if (this.state.sortBy === sortField && this.state.sortDir === 'asc') {
            sortDir = 'desc';
        }else if(this.state.sortBy === sortField && this.state.sortDir === 'desc') {
            sortBy = undefined;
        }
        return this.toggleSort(sortBy, sortDir)
    }

    async toggleSort(sortBy, sortDir) {
        await this.promisedState({sortDir, sortBy});

        return this.fetchResultsForListView();
    }
    renderHeader() {
        return null
    }

    render()
    {
        let {
            isLoading,
            error,
            isSearching,
            isDisabled,
            searchQuery,
            models
        } = this.state;

        return (
            <div className="talent-portal-container">
                <div className='talent-portal-page-container p-8 portal-full max-w-[unset]'>

                    <div className='flex flex-row container mx-auto pb-4'>

                        <div className="basis-6/12 mx-auto">

                            <p>Search {TB.pluralize(this.constructor.modelName)}</p>

                            <StatusFilterDropdown
                                placeholder={this.constructor.searchPlaceholder}
                                options={this.mapSearchResults()}
                                noOptionsMessage={!searchQuery?.length ? 'Search to view results' : 'No Options'}
                                onSearch={value => this.searchKeywords(value || '')}
                                isLoading={isSearching}
                                isDisabled={isDisabled}
                                onChange={this.onKeywordsChange.bind(this)}
                                initValues={TB.flatten(TB.values(this.state.keywordFilters))}
                            />

                        </div>

                        {this.constructor.statusOptions().length > 0 && (
                            <div className="flex-1">

                                <div className="flex flex-row gap-3 items-end">
                                    <div className="flex-grow">
                                        <p>{this.constructor.modelName} Status Filter</p>

                                        <StatusFilterDropdown
                                            placeholder={"Filter By Status..."}
                                            options={this.constructor.statusOptions()}
                                            onChange={this.toggleFilterStatus.bind(this)}
                                            initValues={TB.filter(this.constructor.statusOptions(), ({value}) => this.state.selectedStatuses.includes(value))}
                                        />
                                    </div>

                                    {this.renderActionButton()}
                                </div>
                            </div>
                        )}

                        {this.constructor.sortOptions().length > 0 && (
                            <div className="flex-1">

                                <div className="flex flex-row gap-3 items-end">
                                    <div className="flex-grow">
                                        <p>Sort By</p>

                                        <Select
                                            defaultValue={this.state.sortBy +'_'+ this.state.sortDir}
                                            options={this.constructor.sortOptions()}
                                            onChange={(e, option) => {
                                                this.toggleSort(option.sort_by, option.sort_dir)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* <div className='bg-white p-5 mb-5'>
                        <StatusFilter onFilterChange={this.toggleFilterStatus.bind(this)} />
                    </div> */}

                    <div className="opportunity-list full-card-list">

                        <div className="opportunity-group-container opportunity-admin-group-container">

                            {this.renderHeader()}

                            {this.renderPagination()}

                            <table className={`table table-bordered ${this.constructor.tableClass}`}>
                                <thead>
                                <tr>
                                    {TB.map(this.listHeaders(), (header, i) => (
                                        <th key={`header-${i}`} className={TB.kebabCase(header)}>{header}</th>
                                    ))}
                                </tr>
                                </thead>

                                {!isLoading && !TB.isObject(error) && (
                                    <tbody>
                                        {this.renderResults()}
                                    </tbody>
                                )}

                            </table>

                            {!isLoading && !TB.isObject(error) && TB.isArray(models) && models?.length === 0 && (
                                <EmptyBanner
                                    style={{paddingTop: '200px'}}
                                    message={`No ${TB.pluralize(this.constructor.modelName)} found..`}/>
                            )}

                            {isLoading && (
                                <LoadingBanner message={`Loading ${TB.pluralize(this.constructor.modelName)}`}/>
                            )}

                            {TB.isObject(error) && (
                                <ErrorBanner {...error} onRetry={this.fetchResultsForListView.bind(this)}/>
                            )}

                            {this.renderPagination()}
                        </div>
                    </div>

                    {this.renderListFooter()}
                </div>
            </div>
        );
    }

    renderActionButton() {
        return null;
    }

    renderListFooter() {
        return null
    }

    renderPagination() {

        let {
            isLoading,
            lastPage,
            currentPage,
            isDisabled,
            total,
            models
        } = this.state;

        if (!lastPage || lastPage <= 1) {
            return null
        }

        return (
            <TablePagination
                isDisabled={isLoading || isDisabled}
                handlePageClick={(page) => this.loadMore(page)}
                currentPage={currentPage}
                pagesCount={lastPage}
                total={total}
                perPage={models?.length || PAGE_COUNT}
            />
        )
    }
}